/**
 * JWT payload 디코더 (순수함수, Layer 1 테스트 대상).
 *
 * 원래 `amplifyCompat.ts` 의 `Auth.currentSession` 내부 클로저(`getPayload`)였다.
 * 모킹으로는 검증되지 않는 base64url 파싱 분기를 순수함수로 분리해 직접 단위 테스트한다
 * (establish-test-foundation S2.5). 동작은 추출 전과 동일하다 — 토큰이 없거나 파싱 실패 시 `{}`.
 *
 * aws-amplify 등 무거운 의존이 없어 node 에서 즉시(<1ms) 평가된다.
 */
// 반환 타입은 `Record<string, any>` — 추출 전 인라인 `getPayload` 가 `any` 였고, 소비처
// (`withAuth` 의 `payload["cognito:groups"]` → `includesArrayByArray(_: string[])`)가 `any` 인덱싱에
// 의존한다. `unknown` 으로 좁히면 withAuth 가 컴파일 깨져 next build 가 실패한다(동작 보존).
export const decodeJwtPayload = (token: unknown): Record<string, any> => {
  if (!token) return {};
  try {
    const base64Url = String(token).split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      )
    );
  } catch {
    return {};
  }
};
